// Microsoft Foundry - Agent Service (Responses API).
// Token de acesso vem do backend: POST /api/chat/azure-token
export const AZURE_AGENT_CONFIG = {
  projectEndpoint: "https://flowyhelpdocs-resource.services.ai.azure.com/api/projects/flowyhelpdocs",
  agentName: "Agent741"
};
